module.exports = __webpack_public_path__ + "static/media/alpha_14.2f83054a.png";